import { createRouter, createWebHistory } from 'vue-router';
import MainPage from '@/components/main.vue';
import Login from '@/components/auth/login.vue';
import Register from '@/components/auth/register.vue';
import DestinationList from '@/components/destination/list.vue';
import DestinationView from '@/components/destination/view.vue';
import BookingView from '@/components/booking/booking.vue';
import BusinessRegisterPage from '@/components/auth/bussinessReg.vue';
import CustomerRequestList from '@/components/cusRequest/list.vue';
import OrgrRequestList from '@/components/orgRequest/list.vue';
import PackageList from '@/components/package/listPackage.vue';
import PackageView from '@/components/package/packageView.vue';

import PaymentSuccess from '@/components/payment/Success.vue';
import PaymentFail from '@/components/payment/Fail.vue';

import ApiDocPremium from '@/components/apiDoc/apiDoc.vue';
import ApiDocStanded from '@/components/apiDoc/apiDocStanded.vue';

import ApiPackageList from '@/components/package/apiPackage.vue';

import ProfilePage from '@/components/profile/profile.vue';


const routes = [
  { path: '/', component: MainPage },
  { path: '/login', component: Login },
  { path: '/register', component: Register },
  { path: '/destinationList', component: DestinationList },
  { path: '/place', component: DestinationView },
  { path: '/booking', component: BookingView },
  { path: '/verify-business', component: BusinessRegisterPage },
  { path: '/cus-list', component: CustomerRequestList },
  { path: '/org-list', component: OrgrRequestList },
  { path: '/package-list', component: PackageList },
  { path: '/package-view', component: PackageView },
  { path: '/pay-success', component: PaymentSuccess },
  { path: '/pay-fail', component: PaymentFail },
  { path: '/apiDoc', component: ApiDocPremium},
  { path: '/apiDocStanded', component: ApiDocStanded},
  { path: '/apiPackage', component: ApiPackageList},
  { path: '/profile', component: ProfilePage},
];

const router = createRouter({
  history: createWebHistory(), // Make sure to call createWebHistory() as a function
  routes,
});

export default router;
